import React from "react";
import AccountsIndexContainer from "./AccountsIndexContainer";
import AccountsSortBarContainer from "./AccountsSortBarContainer";
import MainFrameContainer from "./MainFrameContainer";
import Button from "material-ui/Button";
import AddIcon from "material-ui-icons/Add";

const Accounts = props => {
  return (
    <MainFrameContainer
      appBarHeight={100}
      title="Accounts"
      subBar={<AccountsSortBarContainer />}
      body={<AccountsIndexContainer {...props} />}
      fab={
        <Button
          fab
          color="accent"
          style={{ position: "absolute", right: 36, bottom: 20 }}
        >
          <AddIcon />
        </Button>
      }
    />
  );
};

export default Accounts;



// WEBPACK FOOTER //
// ./src/Accounts.js